import React from 'react';
import "./Step.scss";
import moment from 'moment/moment';
import Api from '../../../../services/Api';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../../recoil/atoms/loadingAtom';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
const StepThree = ({ activeStep,setActiveStep,nextStep,prevStep,setPaiement, paiement }) => {
   const url = process.env.REACT_APP_URL?.replace("/api", "") + 'storage/';
   const [loading, setLoading] = useRecoilState(loadingState);
   const api = new Api();
   const navigate = useNavigate();
   //console.log(url);
   const finish = async () => {
    const { reference } = paiement;
     
   try{
      setLoading(true);
      var formData = new FormData();
      //formData.append("device", "mobile");
      const response = await api.apiData("post",`/paiement/apc/setReference?groupID=${reference}`, formData);
      console.log(response);
      if(response.status === 200){
         navigate(`/apc/attestation/print/${reference}`);
      }
      else{
         toast.error("Oops! Une erreur est survenue");

      }
   }catch(error){
     console.log(error);
   }
   finally{
     setLoading(false);
    }
  }
   const openFile = () => {
    if (!paiement?.infovehicule?.dossier) return;
    const pdfUrl = `${url}${paiement.infovehicule.dossier}`;
   
    window.open(pdfUrl, '_blank');
    // Optional: Revoke the object URL after some time to free up memory
   // setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
  } 
    return (
      <div className='step-component step-two'>
        <div className='separator'>
           <h1>Informations du véhicule</h1>
        </div>
        <div className='group-info'>
            <div className='group-info-item'>
                <p>Categorie</p>
                <p>{paiement.infovehicule.categorie || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>Couleur</p>
                <p>{paiement.infovehicule.couleur.charAt(0).toUpperCase() + paiement.infovehicule.couleur.slice(1) || "N/A"}</p>
            </div>
        </div>
        <div className='group-info'>
           <div className='group-info-item'>
                <p>Marque</p>
                <p>{paiement.infovehicule.marque || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>Modèle</p>
                <p>{paiement.infovehicule.modele || "N/A"}</p>
            </div>
            
        </div>
        <div className='group-info'>
           <div className='group-info-item'>
                <p>Chassis</p>
                <p>{paiement.infovehicule.numeroChassis?.join(", ") || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>PTAC</p>
                <p>{paiement.infovehicule.ptac || "N/A"}</p>
            </div>
           
        </div>
        <div className='group-info'>
           <div className='group-info-item'>
                <p>Charge utile</p>
                <p>{paiement.infovehicule.chargeUtile || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>Poids total roulant</p>
                <p>{paiement.infovehicule.poidsTotalRoulant || "N/A"}</p>
            </div>
        </div>
        <div className='group-info'>
            <div className='group-info-item'>
                <p>Poids à vide</p>
                <p>{paiement.infovehicule.poidsAVide || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>Puissance fiscale</p>
                <p>{paiement.infovehicule.puissanceFiscale || "N/A"}</p>
            </div>
        </div>
        <div className="group-info">
            <div className='group-info-item'>
                <p>Date de mise en circulation</p>
                <p>{moment(paiement.infovehicule.dateMiseCirculation).format("DD/MM/YYYY") || "N/A"}</p>
            </div>
            <div className='group-info-item'>
                <p>Pays d'origine</p>
                <p>{paiement.infovehicule.paysProvenance || "N/A"}</p>
            </div>            
        </div>
        <div className='group-info'>
           <div className='group-info-item'>
                <p>Pays destination</p>
                <p>{paiement.infovehicule.paysDestination || "N/A"}</p>
            </div>
            <div className='group-info-item dossier__image' onClick={() => openFile()}>
                <p>Voir le dossier du vehicule</p>
                <p></p>
            </div>
        </div>
        <div className='buttons'>
            <button className="secondary" onClick={prevStep}>Précedent</button>
            <button className="" onClick={finish}>Terminer</button>
        </div>
     </div>
    )
 }
 
 export default StepThree;